import React from 'react';
import { useState } from 'react';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import Select from 'react-select';
import './profileedit.scss';
import { professionalOptions, states, timeZones } from '../../constants';
import Checkbox from '../../components/Checkbox/Checkbox';

const years = [
	{ value: '2022', label: '2022' },
	{ value: '2021', label: '2021' },
	{ value: '2020', label: '2020' },
	{ value: '2019', label: '2019' },
	{ value: '2018', label: '2018' },
	{ value: '2017', label: '2017' },
	{ value: '2016', label: '2016' },
	{ value: '2015', label: '2015' },
	{ value: '2014', label: '2014' },
	{ value: '2013', label: '2013' },
];

function ProfileEdit() {
	const [stepper, setStep] = useState(1);
	const [showMore, setShowMore] = useState(false);
	const [otherSpecialties, setOtherSpecialties] = useState(false);
	return (
		<div className='pedit'>
			<h1>Edit your profile information</h1>
			<div className='pedit_h'>
				<div className='pedit__steps'>
					{[1, 2, 3, 4, 5].map((step) => (
						<div
							className={
								step <= stepper
									? 'pedit__step pedit__step-active'
									: 'pedit__step'
							}
						></div>
					))}
				</div>
				<div>{stepper} of 5</div>
			</div>
			{stepper === 1 && (
				<div>
					<div className='pedit__thirty'>
						<div>
							<span className='pedit_title'>Name:</span>
						</div>
						<div style={{ display: 'flex', gap: '10px' }}>
							<Input
								placeholder='First Name'
								fullStyles={{ marginTop: 'unset' }}
								style={{ padding: '9px 5px' }}
							/>
							<Input
								placeholder='Last Name'
								fullStyles={{ marginTop: 'unset' }}
								style={{ padding: '9px 5px' }}
							/>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div>
							<span className='pedit_title'>Screen Name:</span>
						</div>
						<div
							style={{
								flexDirection: 'column',
								alignItems: 'flex-start',
								gap: '5px',
							}}
						>
							<Input
								placeholder='Screen Name'
								fullStyles={{ marginTop: 'unset' }}
								style={{ padding: '9px 5px' }}
							/>
							<span className='pedit_aside'>
								Profile URL: www.BPOHomes/profile/prefilledname/
							</span>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div>
							<span className='pedit_title'>Profile Photo</span>
							<span>(optional)</span>
						</div>
						<div style={{ flexDirection: 'column' }}>
							<input type='file' accept='image/png, image/jpeg' />
							<span className='pedit_aside'>
								Photo should be at least 180px by 180px and jpg format.
							</span>
						</div>
					</div>
				</div>
			)}
			{stepper === 2 && (
				<div>
					<div className='pedit__thirty'>
						<div>
							<span className='pedit_title'>Professional Category:</span>
						</div>
						<div className='pedit_full'>
							<Select
								isSearchable={false}
								placeholder='Select Professional Category'
								defaultValue={professionalOptions[0]}
								options={professionalOptions}
								styles={{ width: '50%' }}
							/>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div>
							<span className='pedit_title'>Professional Title:</span>
						</div>
						<div>
							<Input
								placeholder='Professional Title'
								fullStyles={{ marginTop: 'unset', width: '100%' }}
								style={{ padding: '9px 5px' }}
							/>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div>
							<span className='pedit_title'>Brokerage Name:</span>
						</div>
						<div>
							<Input
								placeholder='Brokerage Name'
								fullStyles={{ marginTop: 'unset', width: '100%' }}
								style={{ padding: '9px 5px' }}
							/>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div>
							<span className='pedit_title'>Brokerage Address:</span>
						</div>
						<div>
							<Input
								placeholder='Brokerage Address'
								fullStyles={{ marginTop: 'unset', width: '100%' }}
								style={{ padding: '9px 5px' }}
							/>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div>
							<span className='pedit_title'>City, State, Zip:</span>
						</div>
						<div className='pedit_div'>
							<Input
								placeholder='City'
								fullStyles={{ marginTop: 'unset', width: '30%' }}
								style={{ padding: '9px 5px' }}
							/>
							<Select
								placeholder='State'
								options={states}
								// styles={{ width: '50%' }}
							/>
							<Input
								placeholder='City'
								fullStyles={{ marginTop: 'unset', width: '30%' }}
								style={{ padding: '9px 5px' }}
							/>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div>
							<span className='pedit_title'>Timezone:</span>
							<span>&nbsp;(optional)</span>
						</div>
						<div className='pedit_full'>
							<Select placeholder='Timezone' options={timeZones} />
						</div>
					</div>
					<div className='pedit__thirty'>
						<div>
							<span className='pedit_title'>Primary Phone</span>
							<span>&nbsp;(Mobile Preferred)</span>
						</div>
						<div className='pedit_div'>
							<Input placeholder='555' fullStyles={{ width: '15%' }} />
							<Input placeholder='555' fullStyles={{ width: '15%' }} />
							<Input placeholder='5555' fullStyles={{ width: '15%' }} />
						</div>
					</div>
					<div className='pedit__thirty'>
						<div>
							<span className='pedit_title'>Brokerage Phone</span>
							<span>&nbsp;(optional)</span>
						</div>
						<div className='pedit_div'>
							<Input placeholder='555' fullStyles={{ width: '15%' }} />
							<Input placeholder='555' fullStyles={{ width: '15%' }} />
							<Input placeholder='5555' fullStyles={{ width: '15%' }} />
						</div>
					</div>
				</div>
			)}
			{stepper === 3 && (
				<div>
					<div className='pedit__thirty'>
						<div style={{ alignItems: 'flex-start', marginTop: '20px' }}>
							<span className='pedit_title'>Real Estate Agent License:</span>
						</div>
						<div style={{ flexDirection: 'column' }}>
							<div className='pedit__thirty'>
								<div>
									<span className='pedit_title'>State:</span>
								</div>
								<div className='pedit_full'>
									<Select options={states} placeholder='Select State' />
								</div>
							</div>
							<div className='pedit__thirty'>
								<div>
									<span className='pedit_title'>License Number:</span>
								</div>
								<div>
									<Input
										placeholder='License Number'
										fullStyles={{ marginTop: 'unset', width: '90%' }}
										style={{ padding: '9px 5px' }}
									/>
								</div>
							</div>
							<div className='pedit__thirty'>
								<div>
									<span className='pedit_title'>Expiration:</span>
								</div>
								<div>
									<div className='pedit_div'>
										<Input placeholder='DD' fullStyles={{ width: '15%' }} />/
										<Input placeholder='MM' fullStyles={{ width: '15%' }} />/
										<Input placeholder='YYYY' fullStyles={{ width: '15%' }} />
										<Button
											style={{
												width: 'fit-content',
												fontSize: '16px',
												padding: '10px',
												color: 'white',
												backgroundColor: 'var(--primary-color)',
												display: 'block',
												marginLeft: '15px',
											}}
											text='Verify'
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div style={{ alignItems: 'flex-start', marginTop: '20px' }}>
							<span className='pedit_title'>Other Professional Licenses:</span>
							<span>&nbsp;(optional)</span>
						</div>
						<div style={{ flexDirection: 'column' }}>
							<div className='pedit__thirty'>
								<div>
									<span className='pedit_title'>Description:</span>
								</div>
								<div>
									<Input
										placeholder='Enter License Title and/or state issued'
										fullStyles={{ marginTop: 'unset', width: '90%' }}
										style={{ padding: '9px 5px' }}
									/>
								</div>
							</div>
							<div className='pedit__thirty'>
								<div>
									<span className='pedit_title'>License Number:</span>
								</div>
								<div style={{ alignItems: 'center', gap: '10px' }}>
									<Input
										placeholder='License Number'
										fullStyles={{ marginTop: 'unset', width: '90%' }}
										style={{ padding: '9px 5px' }}
									/>
									<p className='pedit_add'>Add</p>
								</div>
							</div>
							<p className='pedit_aside' style={{ margin: '0 15px' }}>
								Licenses must be entered and added one at a time. You must click
								"Add" to add a license to your profile.
							</p>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div style={{ alignItems: 'flex-start', marginTop: '20px' }}>
							<span className='pedit_title'>Service Areas:</span>
							<span>&nbsp;(optional)</span>
						</div>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<div
								style={{
									alignItems: 'center',
									gap: '10px',
									marginLeft: '15px',
									display: 'flex',
									width: '100%',
									justifyContent: 'space-between',
								}}
							>
								<Input
									placeholder='Neighborhood, city, county, zipcode, etc'
									fullStyles={{ marginTop: 'unset', flex: 1 }}
									style={{ padding: '9px 5px' }}
								/>
								<p className='pedit_add'>Add</p>
							</div>
							<p className='pedit_aside' style={{ margin: '0 15px' }}>
								Enter the areas you serve. To add multiple areas, enter your
								first area in the box and click "Add more." Then repeat with
								your next service area.
							</p>
						</div>
					</div>
				</div>
			)}
			{stepper === 4 && (
				<div>
					<div className='pedit__thirty'>
						<div style={{ alignItems: 'flex-start', marginTop: '-12px' }}>
							<span className='pedit_title'>Language Fluency:</span>
							<span>&nbsp;(optional)</span>
						</div>
						<div style={{ flexDirection: 'column' }}>
							<div className='pedit_split'>
								<div>
									<Checkbox text='Spanish' />
									<Checkbox text='German' />
									{showMore && (
										<>
											<Checkbox text='Mandarin' />
											<Checkbox text='Cantonese' />
											<Checkbox text='Arabic' />
											<Checkbox text='Hindi' />
										</>
									)}
								</div>
								<div>
									<Checkbox text='French' />
									<Checkbox text='Polish' />
									{showMore && (
										<>
											<Checkbox text='Italian' />
											<Checkbox text='Thai' />
											<Checkbox text='Korean' />
											<Checkbox text='Greek' />
										</>
									)}
								</div>
							</div>
							<p
								style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
								onClick={() => setShowMore((val) => !val)}
							>
								{showMore ? 'fewer' : 'more'}
							</p>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div>
							<span className='pedit_title'>In business since:</span>
							<span>&nbsp;(optional)</span>
						</div>
						<div className='pedit_div'>
							<Select
								options={years}
								isSearchable={false}
								placeholder='Select year'
							/>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div style={{ alignItems: 'flex-start', marginTop: '-12px' }}>
							<span className='pedit_title'>Specialties:</span>
						</div>
						<div style={{ display: 'unset' }}>
							<p className='pedit_title pedit_title-mb'>Agent Specialties</p>
							<div className='pedit_split'>
								<div>
									<Checkbox text='Buyer Agent' />
									<Checkbox text='Relocation' />
									<Checkbox text='Short Sale' />
									<Checkbox text='Other' />
								</div>
								<div>
									<Checkbox text='Listing Agent' />
									<Checkbox text='Foreclosure' />
									<Checkbox text='Consulting' />
								</div>
							</div>
							<p className='pedit_title pedit_title-mb'>
								Property Management Specialties
							</p>
							<div className='pedit_split'>
								<div>
									<Checkbox text='Property Management' />
								</div>
							</div>
							<p className='pedit_title pedit_title-mb'>
								Other Real Estate Specialties{' '}
								<span
									style={{
										fontWeight: 'normal',
										color: 'var(--primary-color)',
										marginLeft: '10px',
										cursor: 'pointer',
									}}
									onClick={() => setOtherSpecialties((val) => !val)}
								>
									{otherSpecialties ? 'Hide' : 'Show'}
								</span>
							</p>
							{otherSpecialties && (
								<div className='pedit_split'>
									<div>
										<Checkbox text='Appraisal' />
										<Checkbox text='Escrow' />
										<Checkbox text='Legal' />
										<Checkbox text='Notary' />
										<Checkbox text='title' />
									</div>
									<div>
										<Checkbox text='Commercial R.E.' />
										<Checkbox text='Insurance' />
										<Checkbox text='Moving' />
										<Checkbox text='Staging' />
										<Checkbox text='Other' />
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			)}
			{stepper === 5 && (
				<div>
					<div className='pedit__thirty'>
						<div style={{ alignItems: 'center' }}>
							<span className='pedit_title'>Profile Video:</span>
							<span>&nbsp;(optional)</span>
						</div>
						<div>
							<Input
								placeholder='Profile Video'
								fullStyles={{ marginTop: 'unset', width: '100%' }}
								style={{ padding: '9px 5px' }}
							/>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div style={{ alignItems: 'center' }}>
							<span className='pedit_title'>Website:</span>
							<span>&nbsp;(optional)</span>
						</div>
						<div>
							<Input
								placeholder='Website'
								fullStyles={{ marginTop: 'unset', width: '100%' }}
								style={{ padding: '9px 5px' }}
							/>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div style={{ alignItems: 'center' }}>
							<span className='pedit_title'>Blog:</span>
							<span>&nbsp;(optional)</span>
						</div>
						<div>
							<Input
								placeholder='Blog'
								fullStyles={{ marginTop: 'unset', width: '100%' }}
								style={{ padding: '9px 5px' }}
							/>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div style={{ alignItems: 'center' }}>
							<span className='pedit_title'>Facebook:</span>
							<span>&nbsp;(optional)</span>
						</div>
						<div>
							<Input
								placeholder='Facebook'
								fullStyles={{ marginTop: 'unset', width: '100%' }}
								style={{ padding: '9px 5px' }}
							/>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div style={{ alignItems: 'center' }}>
							<span className='pedit_title'>Twitter:</span>
							<span>&nbsp;(optional)</span>
						</div>
						<div>
							<Input
								placeholder='Twitter'
								fullStyles={{ marginTop: 'unset', width: '100%' }}
								style={{ padding: '9px 5px' }}
							/>
						</div>
					</div>
					<div className='pedit__thirty'>
						<div style={{ alignItems: 'center' }}>
							<span className='pedit_title'>LinkedIn:</span>
							<span>&nbsp;(optional)</span>
						</div>
						<div>
							<Input
								placeholder='LinkedIn'
								fullStyles={{ marginTop: 'unset', width: '100%' }}
								style={{ padding: '9px 5px' }}
							/>
						</div>
					</div>
				</div>
			)}

			<div className='pedit_buttons'>
				<Button
					style={{
						width: 'fit-content',
						fontSize: '16px',
						padding: '10px',
						color: 'white',
						backgroundColor: 'var(--primary-color)',
						display: 'block',
						marginRight: 'unset',
					}}
					onClick={() => setStep((cur) => cur + 1)}
					text='Save & Continue'
				/>
				<Button
					style={{
						width: 'fit-content',
						fontSize: '18px',
						padding: '10px',
						background: 'white',
						color: 'var(--primary-color)',
						display: 'block',
					}}
					text='Save & Exit'
				/>
			</div>
		</div>
	);
}

export default ProfileEdit;
